module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_7.f59a9262.png";